export default function ({ app }) {
  const productSpecificTranslations = require(`./${app.$config.CustomProductData.CurrentProductVar}/en.js`).default
  return {
    English: 'English',
    Français: 'French',
    Deutsch: 'German',
    Italliano: 'Italian',
    Español: 'Spanish',
    Next: 'Next',
    Back: 'Back',
    // META DATA
    STEP1_META_TITLE: 'Purchase, buy #PR_NAME# for Microsoft Outlook license.',
    STEP1_META_DESCRIPTION: 'Purchase, buy #PR_NAME# license and activation code. Choose your #PR_NAME# License',
    STEP1_META_KEYWORDS: '#PR_NAME#, purchase, order, buy,  license, upgrade',

    STEP2_META_TITLE: 'Purchase, Buy #PR_NAME# Upgrade and Support',
    STEP2_META_DESCRIPTION: 'Purchase, order or buy #PR_NAME# Support and #PR_NAME# Upgrades. Add License Renewal or Lifetime License',
    STEP2_META_KEYWORDS: '#ProductName#, purchase, order, buy, upgrade, support, license, lifetime license ',

    STEP2_META_TITLE_LTS: 'Purchase, Buy #PR_NAME# Lifetime Subscription',
    STEP2_META_DESCRIPTION_LTS: 'Purchase, order or buy #PR_NAME# Lifetime Subscription.',
    STEP2_META_KEYWORDS_LTS: '#ProductName#, purchase, order, buy, upgrade, support, license, lifetime license ',

    STEP3_META_TITLE: 'Purchase, buy #PR_NAME# for Microsoft Outlook bundles.',
    STEP3_META_DESCRIPTION: 'Purchase, buy #PR_NAME# for Microsoft Outlook bundles. Order #PR_NAME# bundle.',
    STEP3_META_KEYWORDS: '#PR_NAME#, purchase, order, buy, bundle, license',

    STEP4_META_TITLE: 'Purchase, buy Outlook Performance Tune Up.',
    STEP4_META_DESCRIPTION: 'Purchase, buy Outlook Performance Tune Up. Add one session of Outlook configuration, tune up and problem fixing service.',
    STEP4_META_KEYWORDS: 'Outlook Performance Tune Up, purchase, order, buy,  support, license',

    // TOP LINE PAY LATER
    TOP_LINE_PAY_LATER: 'Pay Later.',
    TOP_LINE_PAY_LATER_BAR: 'Interest free bi-weekly payments.',
    TOP_LINE_PAY_LATER_BAR_LINK: 'See how Pay Later works',
    TOP_LINE_PAY_LATER_BLUE_TEXT: 'How it works',
    TOP_LINE_PAY_LATER_FREE_PAYMENTS_HEADER: '{interestPaymentCount} interest free bi-weekly payments of {currency}{amount}',
    TOP_LINE_PAY_LATER_FREE_PAYMENTS_CONTENT: '',

    // PAY LATER MODAL INFO WINDOW
    MODAL_PAY_LATER_EASY_PAY_METHOD_SELECTED:
      '<b>If Pay Later method is selected, you will be charged each 2 weeks.</b><br/> You will then be receiving bi-weekly billing statements with payment due and the remaining balance of your order.',
    MODAL_PAY_LATER_LIST_SCHEMA_TEXT_1: 'No fees',
    MODAL_PAY_LATER_LIST_SCHEMA_TEXT_2: 'No approval needed',
    MODAL_PAY_LATER_LIST_SCHEMA_TEXT_3: 'No price increase',
    MODAL_PAY_LATER_SCHEMA_TITLE: '<b>Pay with 2-weeks installments, without price increase.</b>',
    MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_1: '{orderPayment} - {totalOrderSum} - <b>2 payments</b>',
    MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_2: '{orderPayment} - {totalOrderSum} - <b>3 payments</b>',
    MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_3: '{orderPayment} - {totalOrderSum} - <b>4 payments</b>',
    MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_4: '{orderPayment} - {totalOrderSum} - <b>5 payments</b>',
    MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_5: '{orderPayment} - {totalOrderSum} - <b>6 payments</b>',
    MODAL_PAY_LATER_TOTAL_ORDER_SUM_TITLE: 'Your order is divided into multiple bi-weekly payments according to the total order sum:',

    // STEP 1 TILES
    STEP1_PAGE_H: 'Choose your #PR_NAME# License',
    STEP1_PAGE_H_PRO: 'Choose your #PR_NAME# PRO PLUS License',
    STEP1_PAGE_H_SHORT: 'Choose License',
    STEP1_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license or subscription',

    TILE_LICENSE_TITLE: '<b>User License</b>',
    TILE_LICENSE_TITLE_DIV: 'User License',
    TILE_LICENSE_DESCRIPTION: '1 year of free upgrades and free support is included.',
    TILE_LICENSE_MODAL_TITLE: '<b>#PR_NAME# User License</b>',
    TILE_LICENSE_DESCRIPTION2: '',
    TILE_LICENSE_MODAL_DESCRIPTION: 'In addition to user license you get 1 year of free upgrades and technical support.',
    TILE_BADGE_LIMITED_OFFER: ' off. Limited Time Offer',

    TILE_SINGLE_LIC_UPGRADE_TITLE: '<b>User License Renewal</b>',
    TILE_SINGLE_LIC_UPGRADE_TITLE_DIV: 'User License Renewal',
    TILE_SINGLE_LIC_UPRAGE_DESCRIPTION: 'If already own a license. Get the latest Product version and additional year of Product Updates and Support.',
    TILE_SINGLE_LIC_UPGRADE_MODAL_TITLE: '<b>#PR_NAME# User License Renewal</b>',
    TILE_SINGLE_LIC_UPGRADE_MODAL_DESCRIPTION: 'If already own a license. Get the latest Product version and additional year of Product Updates and Support.',

    // STEP2
    STEP2_PAGE_H: 'Add License Renewal or Lifetime License',
    STEP2_PAGE_H_SHORT: 'Select Renewal',
    STEP2_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',

    // STEP2
    TILE_LIC_UPGRADE_TITLE: '<b>License Renewal<br>for Additional Year</b>',
    TILE_LIC_UPGRADE_TITLE_DIV: 'License Renewal for Additional Year',
    TILE_LIC_UPRAGE_DESCRIPTION: 'Add additional year of Upgrade and Maintenance Plan.',
    TILE_LIC_UPGRADE_MODAL_TITLE: 'License Renewal for Additional Year',
    TILE_LIC_UPGRADE_MODAL_DESCRIPTION: 'Get the latest Product version and additional year of Product Updates and Support.',

    TILE_LIFETIME_UPGRADE_TITLE: '<b>Lifetime License</b>',
    TILE_LIFETIME_UPGRADE_TITLE_DIV: 'Lifetime Licens',
    TILE_LIFETIME_UPRAGE_DESCRIPTION: 'Perpetual software license. Lifetime updates and support.',
    TILE_LIFETIME_UPGRADE_MODAL_TITLE: 'Lifetime License',
    TILE_LIFETIME_UPGRADE_MODAL_DESCRIPTION: 'Perpetual software license. Lifetime updates and support.',

    // STEP2 SUBSCRIPTIONS
    STEPS_BAR_STEP2_LTS: 'Lifetime Subscription',
    STEP2_PAGE_H_LTS: 'Add License Renewal or Lifetime License',
    STEP2_PAGE_H_SHORT_LTS: 'Select Renewal',
    STEP2_PAGE_DESCRIPTION_LTS: 'Every user account on each PC needs an individual license or subscription',
    // STEP3
    STEP3_PAGE_H: 'Bundle and Save Big',
    STEP3_PAGE_H_SHORT: 'Bundle',
    STEP3_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',
    TILE_BUNDLE_ALLYOUCANEAT_TITLE: '<b>All You Can Eat Bundle</b>',
    TILE_BUNDLE_ALLYOUCANEAT_TITLE_DIV: 'All You Can Eat Bundle',
    TILE_BUNDLE_ALLYOUCANEAT_DESCRIPTION1: 'All 4Team utilities for Microsoft Outlook. Includes synchronization, duplicate management, backup tools.',
    TILE_BUNDLE_ALLYOUCANEAT_TITLE_MODAL: '<b>All You Can Eat Bundle</b>',
    TILE_BUNDLE_ALLYOUCANEAT_DESCRIPTION_MODAL: 'Buy All You Can Eat Bundle and you will receive:',
    TILE_BUNDLE_ALLYOUCANEAT_S2_DESCRIPTION: ' - Synchronize Microsoft Outlook data between multiple PC’s.',
    TILE_BUNDLE_ALLYOUCANEAT_S2C_DESCRIPTION: ' - Synchronize Microsoft outlook data with multiple sources: iCloud, Google, Microsoft Exchange.',
    TILE_BUNDLE_ALLYOUCANEAT_DR_DESCRIPTION: ' - find and remove Outlook duplicate items in just one click.',
    TILE_BUNDLE_ALLYOUCANEAT_SPB_DESCRIPTION: ' - automatic Outlook PST and Exchange folders backup tool.',
    TILE_BUNDLE_ALLYOUCANEAT_OT_DESCRIPTION: ' - resolve Outlook problems with Outlook toolbox.',
    TILE_BUNDLE_ALLYOUCANEAT_VC_DESCRIPTION: ' - easily Transfer Contacts between Multiple files and Cloud sources.',
    TILE_BUNDLE_ALLYOUCANEAT_AND_MORE: 'and more',
    TILE_BADGE_RECOMMENDED: 'Recommended',

    // STEP4
    STEP4_PAGE_H: 'Extras',
    STEP4_PAGE_SHORT: 'Extras',
    STEP4_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',
    TILE_OUTLOOKTUNEUP_TITLE: '<b>Outlook Performance<br/>Tune Up</b>',
    TILE_OUTLOOKTUNEUP_TITLE_DIV: 'Outlook Performance Tune Up',
    TILE_OUTLOOKTUNEUP_DESCRIPTION1:
      'An online session with our 5-Star Support Professionals. You will get your Outlook configured, tuned up and fixed in no time!',
    TILE_OUTLOOKTUNEUP_MODAL_TITLE: '<b>Outlook Performance<br/>Tune Up</b>',
    TILE_OUTLOOKTUNEUP_MODAL_DESCRIPTION:
      'An online session with our 5-Star Support Professionals. You will get your Outlook configured, tuned up and fixed in no time!',

    // Tiles buttons
    TILE_BTN_ADD_TO_CART: 'Add to cart',
    TILE_BTN_UNSELECT: 'Unselect',
    TILE_BTN_SELECT: 'Select',
    TILE_BTN_REMOVE: 'Remove',
    TILE_BTN_SELECTED: 'Selected',
    TILE_BTN_CHAT_NOW: 'Chat now',
    TILE_BTN_CLOSE: 'Close',

    //
    SKIP_BNT: 'Skip',
    SKIP_BNT_LAST: 'Skip',

    // SUBSCRIPTION TILES
    TILE_SUBSCRIPTION_TITLE3: '<b>User License Subscription</b>',
    TILE_SUBSCRIPTION_TITLE_DIV: 'User License Subscription',
    TILE_SUBSCRIPTION_DESCRIPTION: 'Annual subscription. Free Upgrades and Support while your subscription is active. Cancel any time.',
    TILE_SUBSCRIPTION_MODAL_TITLE: '#PR_NAME# User License Subscription',
    TILE_SUBSCRIPTION_MODAL_DESCRIPTION: 'Annual subscription. Free Upgrades and Support while your subscription is active. Cancel any time.',

    // SUBSCRIPTION LT TILES
    TILE_SUBSCRIPTION_LT_TITLE3: '<b>Lifetime Subscription</b>',
    TILE_SUBSCRIPTION_LT_TITLE_DIV: 'Lifetime Subscription',
    TILE_SUBSCRIPTION_LT_DESCRIPTION: 'Upgrade to Lifetime subscription and never pay an annual fee again.',
    TILE_SUBSCRIPTION_LT_MODAL_TITLE: '#PR_NAME# Lifetime Subscription',
    TILE_SUBSCRIPTION_LT_MODAL_DESCRIPTION: 'Upgrade to Lifetime subscription and get free upgrades and support for the product lifetime.',

    // Tiles links
    TILE_LINK_LEARN_MORE: 'Learn more',
    TILE_LINK_WHY_UPGRADE: 'Why Renew?',
    TILE_LINK_WHY_LIFETIME_UPGRADE: 'Why Lifetime License?',
    TILE_LINK_WHY_SUBSCRIPTION: 'Why Subscription is better?',
    TILE_LINK_SUBSCRIPTION_VS_LICENSE: 'License vs Subscription',
    TILE_LINK_CHOOSE_SUBSCRIPTION: 'Choose Subscription',
    TILE_TEXT_CHOOSE_SUBSCRIPTION: 'and never worry about renewals and missing important upgrades.',
    TILE_LINK_WHY_TECH_LIC_UPGRADE: 'Concurrent use license. Learn more.',

    // Tiles Price & Save
    TILE_PAY_LATER_NAME: 'Pay Later',
    TILE_PAY_LATER_NAME_MODAL: 'Pay Later',
    TILE_PAY_LATER_NUMBER_OF_PAYMENTS: '{numberOfPayments} payments',
    TILE_PAY_LATER_NUMBER_OF_PAYMENTS_MODAL: '{numberOfPayments} payments',
    TILE_PAY_LATER_TEXT: 'or {payLaterText} {br} {numberOfPayments} of {paymentAmount}',
    TILE_PAY_LATER_TEXT_MODAL: 'or {payLaterText} {br} {numberOfPayments} of {paymentAmount}',
    TILE_LISTPRICE_SAVE: 'List Price: {oldPrice} You Save {percentageDiscount}%',
    TILE_LISTPRICE_SAVE_MODAL: 'List Price: {oldPrice} You Save {percentageDiscount}%',
    TILE_LISTPRICE_SAVE_2STEP: 'List Price: {oldPrice} You Save {percentageDiscount2step}%',
    TILE_LISTPRICE_SAVE_MODAL_2STEP: 'List Price: {oldPrice} You Save {percentageDiscount2step}%',

    // MODAL WHY UPGRADE
    MODAL_WHY_UPGRADE_TITLE: 'Why Renew?',
    MODAL_WHY_UPGRADE_DESCTIPTION:
      'With the User License Renewal purchase, you will receive <b>1 year of free software upgrades</b> as well as our <b>free online support via Live Chat</b><br> <b>We highly recommend upgrading your software license annually.</b>',
    MODAL_WHY_UPGRADE_PURCHASE_TITLE: 'How to Purchase the License Renewal?',
    MODAL_WHY_UPGRADE_PURCHASE_TEXT:
      'If you have used the product for more than 1 year and want an upgrade, please select <b>Product Renewal</b>. Then in the shopping cart please select license quantity that you own and want to upgrade. After the order confirmation you are eligable to use the upgraded version of the software for another year.<br><br>Your original license is valid indefinately. If you save the original downloadable program file, you will be able to use it at any time in the future.<br><br>Every user needs an individual license for each PC. If two users use the same PC, they will need two licenses, if they log in to different Windows profiles.',

    // MODAL WHY LIFETIME UPGRADE
    MODAL_WHY_LT_UPGRADE_TITLE: 'Why Purchasing the Lifetime License?',
    MODAL_WHY_LT_UPGRADE_DESCTIPTION:
      '<p>Your original software license is limited to only 1 year of Free Upgrades and Support. Benefits of purchasing the Lifetime Renewal:</p><ul class="modal-description-ul"><li> Substantial money(50% Off) and time savings.</li><li>Paying for the software and its support once you get one code to activate the product.</li ><li>Remove the risk of price increase of software updates and support.</li><li>Free future software upgrades and updates.</li><li>Free software technical support via email and Live Chat.</li><li>You will be able to transfer license to another PC (3 times/year).</li><li>Special offers for additional licenses and related products and services.</li></ul>',
    MODAL_WHY_LT_UPGRADE_PURCHASE_TITLE: 'How to Purchase the Lifetime License?',
    MODAL_WHY_LT_UPGRADE_PURCHASE_TEXT:
      '<ol class="modal-description-ol"><li> Choose the “Lifetime License Renewal”;</li><li>Select license quantity that you own;</li><li>Free future software upgrades and updates.</li><li>Free software technical support either via email or Live Chat.</li></ol>',
    MODAL_WHY_LT_UPGRADE_NOTE:
      '<a href="testimonials.aspx" title="Read our Customers Reviews or Submit your feedback">Read our Customers Reviews or Submit your feedback</a>. Your opinion is extremely important.',
    //

    // MODAL WHY SUBSCRIPTION UPGRADE
    MODAL_WHY_SUBSCRIPTION_TITLE: 'Why Subscription is better?',
    MODAL_WHY_SUBSCRIPTION_DESCRIPTION:
      '<p>Your original software license is limited to only 1 year of Free Upgrades and Support. Benefits of purchasing the Annual Subscription:</p><ul class="modal-description-ul"><li>Never miss critical upgrades</li><li>Access to latest product features</li><li>Always available free support when you need it (review)</li><li>More affordable. Cancel any time.</li></ul>',
    DISCOUNTS_AFTER_ADD_TO_CART: 'Discounts, if any, are applied AFTER you click "Add to Cart". You can change license quantity in the Shopping Cart.',
    PAYLATER_AFTER_ADD_TO_CART: 'When available, you can choose the Pay Later option, after Check Out when selecting your payment method.',

    // MODAL BUNDLES ADDITIONAL TEXT
    MODAL_BUNDLE_BUY_NOW: 'Buy Now',
    MODAL_BUNDLES_BUY_SEPARATELLY: 'If Bought Separately',
    MODAL_BUNDLES_BUY_AS_BUNDLE: 'If Bought as Bundle',

    // MODAL LIFETIME ADDITIONAL TEXT
    MODAL_LIFETIME_BUY_NOW: 'Buy Now',
    MODAL_LIFETIME_BUY_FULL_PRICE: 'Full Price',
    MODAL_LIFETIME_BUY_LIST_PRICE: 'If Bought Separately',

    // PURCHASE STEPS BAR
    STEPS_BAR_BTN_BACK: 'Back',
    STEPS_BAR_STEP1: 'Licenses',
    STEPS_BAR_STEP2: 'Upgrades',

    STEPS_BAR_STEP3: 'Bundles',
    STEPS_BAR_STEP4: 'Extras',
    STEPS_BAR_STEP5: 'Billing Info',
    STEPS_BAR_STEP6: 'Checkout',
    STEPS_BAR_STEP7: 'Subscriptions',
    STEPS_BAR_STEP8: 'Completed',
    STEPS_BAR_BTN_NEXT: 'Next',
    STEPS_BAR_BTN_ADD_TO_CART: 'Go to Cart',
    STEP_BAR_SELECT_ANY_OPTON_TOOLTIP: 'Select any option above to proceed',
    STEP_BAR_TRUST_SOFTWARE: 'The software you can trust.',
    STEP_BAR_EULA: 'Licensing (EULA)',
    STEP_BAR_EULA_TITLE: 'Licensing (EULA)',

    // NOTES AND PAYMENT CARDS ICONS
    PAYMENT_TOP_CAPTION: 'No commitment. {privacyPolicy} and {systemRequirements}. The software you can trust. {licensingEula}',
    PAYMENT_MAIN_TEXT_HEADING: 'Money Back Guarantee',
    PAYMENT_MAIN_TEXT:
      '* We are eager to make sure that you will be really happy with your purchase. <br> We will refund the full amount if our technicians are not able to make the software work on your computer during 14-day money back performance guarantee period after purchase.',
    PAYMENT_MAIN_TEXT_REFUND: '** Product Bundles are not refundable',
    PAYMENT_MAIN_TEXT_BOTTOM: 'Refund policy',

    ICON_VISA_TITLE: 'Visa',
    ICON_AMERICAN_EXPRESS_TITLE: 'American Express',
    ICON_MASTER_CARD_TITLE: 'MasterCard',
    ICON_DISCOVER_NETWORK_TITLE: 'Discover',
    ICON_WIRE_TRANSFER_TITLE: 'Wire Transfer',
    ICON_PURCHASE_ORDER_TITLE: 'Purchase Order',
    ICON_MONEY_ORDER_TITLE: 'Money Order',
    ICON_CHECK_TITLE: 'Check',
    ICON_PAYPAL_TITLE: 'PayPal',
    ICON_PAY_LATER_TITLE: 'Pay Later',

    ICON_MICROSOFT_GOLD_CERTIFIED_TITLE: 'Microsoft Gold Certified Partner',
    ICON_MONEY_BACK_GUARANTEE_TITLE: 'Money Back Satisfaction guarantee',
    ICON_MONEY_BACK_TITLE: 'Money Back Satisfaction guarantee',

    // INFO LINKS
    PAYMENT_INFO_LINK_RP: 'Refund policy',
    PAYMENT_INFO_LINK_RP_TITLE: 'Refund policy',
    PAYMENT_INFO_LINK_SR: 'System Requirements',
    PAYMENT_INFO_LINK_SR_TITLE: 'System Requirements',
    PAYMENT_INFO_LINK_EULA: 'Licensing (EULA)',
    PAYMENT_INFO_LINK_EULA_TITLE: 'Licensing (EULA)',
    PAYMENT_INFO_LINK_FAQ: 'Frequently Asked Questions',
    PAYMENT_INFO_LINK_FAQ_TITLE: 'Frequently Asked Questions',

    // FOOTER
    FOOTER_BOTTOM_COPYRIGHT: '{corporationName} All rights reserved',
    FOOTER_DISCOUNTS:
      'Discounts, if any, are applied AFTER you click "Add to Cart" and move to the shopping cart page.<br>Multiple discounts are not applied.<br>Product bundles are not refundable.<br>Every user account on each workstation needs an individual license.<br>Every license includes: 1 year of free updates and free support via e-mail and Live Help.<br>Check individual software products for localization information.<br>"Pay Later" price is just one part of payment depending on payment schedule.',
    FOOTER_BOTTOM_MAIN_TEXT:
      'Microsoft and the Office logo are registered trademarks of Microsoft Corporation in the United States and/or other countries. Apple and the iPhone, iCloud, iTunes logos are registered trademarks of Apple Inc. In the United States and/or other countries. Google and the Google Calendar, Google Contacts, Google Tasks logos are registered trademarks of Google LLC. In the United States and/or other countries.',
    FOOTER_BUTTON_NAME_1: 'About Us',
    FOOTER_BUTTON_NAME_2: 'Privacy',
    FOOTER_BUTTON_NAME_3: 'Terms',
    FOOTER_BUTTON_TITLE_1: 'Click here to learn about 4Team Corporation',
    FOOTER_BUTTON_TITLE_2: 'Click here to read Privacy Policy',
    FOOTER_BUTTON_TITLE_3: 'Click here to read Terms of Use',
    FOOTER_BUTTONS_COUNT: '3',
    FOOTER_INPUT_LABEL: 'Keep me posted on the latest news',
    FOOTER_INPUT_PLACEHOLDER: 'Type your Email address here',
    FOOTER_CORPORATION_NAME: '4Team Corporation',
    FOOTER_ICON_TEAM_LOGO_TITLE: '4Team Corporation',

    // EMAIL VALIDATION
    VALIDATION_EMAIL_INVALID: 'Inavalid e-mail.',
    VALIDATION_REQUIRED: 'Required',

    // GLEAM BANNER
    GLEAM_BANNER_DISCOUNT_TEXT_PROMO_CODE: 'Your 50% discount Promo Code:',
    GLEAM_BANNER_DISCOUNT_TEXT_PRODUCT_WIIL_COST: '#PR_NAME# will cost you',
    GLEAM_BANNER_PROMO_TEXT_SUBSCRIPTION: 'Your 50% discount to #PR_NAME# Annual Subscription has been applied!',
    GLEAM_BANNER_DISCOUNT_TEXT_APPLY_DISCOUNT: 'Enter your Promo Code in the Shopping Cart to take advantage of this discount.',

    // BILLING INFO
    PER_YEAR: '/year',
    SUBSCRIBE_FOR: 'Subscribe for {price}',
    SUBSCRIBE_TITLE: 'Subscribe',
    INPUT_FIRST_NAME_LABEL: 'First name',
    INPUT_LAST_NAME_LABEL: 'Last name',
    INPUT_EMAIL_LABEL: 'Email',
    INPUT_PHONE_LABEL: 'Phone',
    INPUT_COMPANY_LABEL: 'Company',

    INPUT_FIRST_NAME_PLACEHOLDER: 'Enter your first name',
    INPUT_LAST_NAME_PLACEHOLDER: 'Enter your last name',
    INPUT_EMAIL_PLACEHOLDER: 'Enter your e-mail',
    INPUT_PHONE_PLACEHOLDER: 'Enter phone number (optional)',
    INPUT_COMPANY_PLACEHOLDER: 'Enter company name (optional)',
    INPUT_EMAIL_ERROR: 'Please enter valid email',

    STEP5_PAGE_H: 'Provide your Billing Information',
    STEP5_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual subscription',
    STEP5_PAGE_SHORT: '',
    STEP5_META_TITLE: '#PR_NAME# Subscription - Billing Information',
    STEP5_META_DESCRIPTION: 'Provide your Billing Information',
    STEP5_META_KEYWORDS: '#PR_NAME#,subscription,billing',

    // checkout INFO
    STEP6_PAGE_H: 'Choose Payment Method',
    STEP6_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual subscription',
    STEP6_PAGE_SHORT: '',
    STEP6_META_TITLE: '#PR_NAME# Subscription - Payment Method',
    STEP6_META_DESCRIPTION: 'Choose your Payment Method',
    STEP6_META_KEYWORDS: '#PR_NAME#,subscription,billing,payment method',
    TXT_TOTAL: 'Total: ',

    // COMPLETED INFO
    STEP8_META_TITLE: '#PR_NAME# Subscription - Successful Payment',
    STEP8_META_DESCRIPTION: '',
    STEP8_META_KEYWORDS: '',

    // payment receved
    STEP8_PAGE_PR_H: 'Receipt',
    STEP8_PAGE_PR_DESCRIPTION: 'Thank you for subscribing!',
    STEP8_PAGE_PR_INSTRUCTIONS: 'Your payment has been successfully approved.',
    STEP8_PAGE_PR_ACTIVATION_CODE: 'Your Order ID and Activation Code: ',
    STEP8_PAGE_PR_PRINT_INVOICE:
      '<a href="https://www.4team.biz/member/invoice.asp?oid=#Order_NUM#&uid=#UID#" target="_blank">Click here to print your invoice.</a>',
    STEP8_PAGE_PR_ACTIVATION:
      'We have sent you the Activation Code by email.<br/>If you don’t receive it in 2 hours, please please contact us at <a href=""mailto:sales@4team.biz"">sales@4team.biz</a>',
    STEP8_PAGE_PR_SHORT: 'Receipt',
    STEP8_PAGE_PR_ACTIVATION_INSTRUCTIONS:
      'You can <b>activate the trial software</b> version by going to the product menu located in Microsoft Outlook Help menu, Product menu or Product Help menu -> About Product -> Activate... and entering your Activation code in the "Activation code" field. The program will continue functioning as a full version. <br/>There is no need to reinstall the software if the trial version of the software is already installed; you just need to activate it. ',
    STEP8_PAGE_PR_DOWNLOAD_LINK: '<b>Download links:</b> <br/>',
    STEP8_PAGE_PR_MANAGE_SUBSCRIPTION:
      'You can manage your subscription by visiting this <a href="https://billing.stripe.com/p/login/28o3d9dpW0O9cGA000?prefilled_email=#customer_email#" target="_blank">link<a/>',
    STEP8_PAGE_PR_BANNER_TEXT:
      'Don’t have time installing and configuring the software yourself?<br/>Let us do the work for you. You can use our Premium Support service to get  everything configured as you want remotely. ',
    STEP8_PAGE_PR_BANNER_BUTTON_GET_HELP: 'Get Help Now',
    STEP8_PAGE_PR_BANNER_LINK_WHY_PREMIUM: 'Why Premium?',
    STEP8_PAGE_PR_DOWNLOAD_INSTRUCTIONS:
      'Please download the software setup file and keep it in a safe place  in case of a system failure or re-installation. We provide links to the latest version of the software only. You will not be able to activate and use of the software if your subscription has expired.',
    // payment error
    STEP8_PAGE_PE_H: 'Error',
    STEP8_PAGE_PE_DESCRIPTION: 'This transaction cannot be processed. Please enter a valid credit card number and type.',
    STEP8_PAGE_PE_INSTRUCTIONS: 'Please, check your credit card data (number, billing address associated with it, expiration date) and try again. ',
    STEP8_PAGE_PE_SHORT: 'Error',

    // payment pending
    STEP8_PAGE_PP_H: 'Order Pending',
    STEP8_PAGE_PP_DESCRIPTION: "We'll send you the order confirmation and activation code when the payment is confirmed.",
    STEP8_PAGE_PP_INSTRUCTIONS: '',
    STEP8_PAGE_PP_SHORT: 'Order Pending',

    // payment internal error
    STEP8_PAGE_PIE_H: 'Error',
    STEP8_PAGE_PIE_DESCRIPTION: 'An unknown error occurred!',
    STEP8_PAGE_PIE_INSTRUCTIONS_1: 'If the problem persists, please contact us at ',
    STEP8_PAGE_PIE_INSTRUCTIONS_2: 'If the problem persists, please contact us at "<a href=""mailto:sales@4team.biz"">sales@4team.biz</a>',
    STEP8_PAGE_PIE_SHORT: 'Error',

    // payment canceled
    STEP_8_PAGE_PC_H: 'Order Cancelled',
    STEP8_PAGE_PC_SHORT: 'Order Cancelled',
    STEP_8_PAGE_PC_INSTRUCTIONS: 'Your payment was not completed for some reason. Please try again by choosing the subscription on the ',
    STEP_8_PAGE_PC_INSTRUCTIONS_2: '',
    STEP_8_PAGE_PC_INSTRUCTIONS_LINK_TEXT: 'first purchase step',
    STEP_8_PAGE_PC_CONTACTS_LINK_TEXT: 'Contact our support team',
    STEP_8_PAGE_PC_CONTACTS: ' if you need help with the order.',
    PURCHASE_IN_PROGRESS: 'Purchase is processing, this may take up to 5 min, please wait',
    INPUT_REQUIRED: 'Field is required',
    UPGRADE_TO: 'Upgrade to',

    CALCULATING__AVAILABLE_PAYMENT_METHODS: 'Checking for available payment methods. Please wait...',

    ...productSpecificTranslations,
  }
}
